import { createRouter } from '@tanstack/react-router'
import type { getAppProviderContext } from '@/app/providers'
import type { DocumentRecordClient } from '@/integrations/zustand-store/document-record-client'
import type { CurrentUserWithPermissions } from '@/shared/lib/workspace-permissions'
import { routeTree } from '@/routeTree.gen'
import { reportFrontendError } from '@/observability/monitoring'

export function createAppRouter({
  providers,
  currentUser,
  records,
}: {
  providers: ReturnType<typeof getAppProviderContext>
  currentUser: CurrentUserWithPermissions | null
  records: DocumentRecordClient
}) {
  return createRouter({
    routeTree,
    context: {
      ...providers.tanstackQuery,
      ...providers.apollo,
      ...providers.zustand,
      currentUser,
      records,
    },
    defaultPreload: 'intent',
    scrollRestoration: true,
    defaultStructuralSharing: true,
    defaultPreloadStaleTime: 0,
    defaultOnCatch: (error, info) => reportFrontendError(error, 'router', info),
  })
}
